import React from "react";
import "./Quote.css";

const Quote = () => {
  return (
    <div className="quote-section">
      <div className="quote-box">
        <h4 className="quote-title">
          The Impact Stories Fund (ISF) is funded by SPARK Publicity. 
          The project is dedicated to amplifying transformative narratives that showcase the real-world impact of social initiatives. 
          We carefully vet stories, films, and distribute compelling documentaries, podcasts, and programs to inspire action and foster meaningful change.
          {/* <br /> <br />~ Impact Stories Fund Ambassador */}
        </h4>
      </div>
    </div>
  );
};

export default Quote;
